import get from 'lodash/get';
import VoteButton from '../vote-button';
import config from '../../config';
import useLazyImage from '../../hooks/useLazyImage';
import styles from './ProductListItem.module.scss';

function ProductListItem({ product, lang }) {
  const isEnglish = lang === 'en';
  const imageUrl = get(product, 'coverImage.formats.medium.url', get(product, 'coverImage.url', 'https://placehold.co/400x400'));
  const teamNumber = get(product, 'ordering') ? `${get(product, 'ordering')} - ` : '';
  const title = get(product, isEnglish ? 'titleEN' : 'titleTC', 'N/A');
  const school = get(product, isEnglish ? 'schoolEN' : 'schoolTC', 'N/A');
  const voteBatch = get(product, 'voteBatch', null);
  const productUrl = `${config.basePath || ''}/product/?id=${product?.documentId}`;

  // Use lazy loading for images
  const { imageSrc, imageRef, isLoaded } = useLazyImage(imageUrl);

  // Handle missing product
  if (!product) {
    return null;
  }

  return (
    <div className={styles.productCard}>
      <a href={productUrl} className={styles.productCardLink}>
        <div className={styles.productCardInner}>
          <img
            ref={imageRef}
            className={`${styles.productImage} ${isLoaded ? styles.loaded : ''}`}
            src={imageSrc}
            alt={title}
            loading="lazy"
          />
          <div className={styles.productInfo}>
            <div className={styles.productTitle}>{title}</div>
            <div className={styles.school}>{school}</div>

            <VoteButton
              votes={get(product, 'votes', 0)}
              documentId={get(product, 'documentId', '')}
              voteBatch={voteBatch}
            />
          </div>
        </div>
      </a>
    </div>
  );
}

export default ProductListItem;
